import React from 'react';
import { V2ThemeProvider } from '../../../themecontrols/v2_ThemeContext';
import V2TraceabilityTab from './tabs/V2TraceabilityTab';
import '../../../themecontrols/themecontrol.css';
import './v2_DashboardPage.css';

// Fixed sentinel value — backend ignores workspace_id for this public endpoint
const PUBLIC_RTM_WORKSPACE_ID = '0';

/**
 * V2TraceabilityPublicPage - Standalone public Traceability (RTM) page.
 *
 * Accessible without login at /rtm
 * Uses the real API — backend bypasses auth for dashboard-rtm-data.
 * Theme CSS variables are applied via V2ThemeProvider.
 */
function V2TraceabilityPublicPage() {
  return (
    <V2ThemeProvider>
      <div className="v2-dashboard-page v2-dashboard-page--standalone">
        <div className="v2-dashboard-header">
          <div className="v2-dashboard-tabs">
            <button className="v2-dashboard-tab v2-dashboard-tab--active">
              Traceability (RTM)
            </button>
          </div>
        </div>
        <div className="v2-dashboard-content">
          <V2TraceabilityTab workspaceId={PUBLIC_RTM_WORKSPACE_ID} />
        </div>
      </div>
    </V2ThemeProvider>
  );
}

export default V2TraceabilityPublicPage;
